import { BodySmallRegular, View } from 'smoothie';

import type { PasswordRequirementsFeedback } from '../types/Auth';

enum PasswordRequirementsFeedbackMessages {
    MissingComplexity = 'Must include at least 3 of the following: lowercase, uppercase, number, and symbol.',
    MissingCharacters = 'Must be 10 characters long',
    BreachedPassword = 'This password may have been used on a different site that experienced a security issue. Please choose another password.',
}

const metColor = '$green700';
const notMetColor = '$gray900';
const errorColor = '$red1100';

export const PasswordRequirements = ({
    validPassword,
    passwordFeedback,
}: {
    validPassword: boolean;
    passwordFeedback: PasswordRequirementsFeedback | null;
}) => {
    return (
        <View display="inline">
            {passwordFeedback?.breachedPassword ? (
                <BodySmallRegular key="breach" color={errorColor}>
                    {PasswordRequirementsFeedbackMessages.BreachedPassword}
                </BodySmallRegular>
            ) : (
                <View key="checklist" display="inline">
                    <BodySmallRegular
                        display="inline"
                        color={
                            validPassword ||
                            passwordFeedback?.missingCharacters === 0
                                ? metColor
                                : notMetColor
                        }
                        animation="quick"
                        animateOnly={['color']}
                    >
                        {PasswordRequirementsFeedbackMessages.MissingCharacters}
                    </BodySmallRegular>
                    <BodySmallRegular
                        color={validPassword ? metColor : notMetColor}
                        animation="quick"
                        animateOnly={['color']}
                    >
                        {', and '}
                    </BodySmallRegular>
                    <BodySmallRegular
                        display="inline"
                        color={
                            validPassword ||
                            passwordFeedback?.missingComplexity === 0
                                ? metColor
                                : notMetColor
                        }
                        animation="quick"
                        animateOnly={['color']}
                    >
                        {PasswordRequirementsFeedbackMessages.MissingComplexity.toLowerCase()}
                    </BodySmallRegular>
                </View>
            )}
        </View>
    );
};
